import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';

const Header = () => {
  const handleJoinClick = () => {
    // Trigger custom event to open PayPal modal
    window.dispatchEvent(new CustomEvent('openPayPalModal'));
  };

  return (
    <header className="site-header">
      <div className="container">
        <div className="header-content">
          <Link to="/" className="logo-link">
            <img 
              src="https://customer-assets.emergentagent.com/job_creator-toolkit-18/artifacts/4urdmjk2_pixel56%20logo%28500%20x%20300%20px%29.png" 
              alt="Pixel56 Logo" 
              className="logo-image"
            />
          </Link>
          <nav className="header-nav">
            <Button 
              variant="default" 
              size="sm"
              className="header-cta-btn"
              onClick={handleJoinClick}
            >
              Mitglied werden
            </Button>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
